// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[data-v-022cc1e2]::-webkit-outer-spin-button,\ninput[data-v-022cc1e2]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"][data-v-022cc1e2] {\n  -moz-appearance: textfield;\n}\n", ""]);
// Exports
module.exports = exports;
